import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import marketService from '../services/marketService';
import useAuth from '../hooks/useAuth';
import './MarketList.css';

const MarketList = () => {
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const fetchPlayers = async () => {
      setLoading(true);
      setError(null);
      try {
        const { success, data, error } = await marketService.getAll();
        if (success) {
          setPlayers(data || []);
        } else {
          setError(error || 'Dados não encontrados');
          setPlayers([]);
        }
      } catch (err) {
        console.error('Erro ao buscar jogadores:', err);
        setError('Erro ao conectar com o servidor');
        setPlayers([]);
      } finally {
        setLoading(false);
      }
    };
    fetchPlayers();
  }, []);

  const handleViewDetails = (playerId) => navigate(`/market/details/${playerId}`);
  const handleEditPlayer = (playerId) => navigate(`/market/edit/${playerId}`);

  const renderSection = (title, filteredPlayers) => (
    <>
      {filteredPlayers.length > 0 && (
        <>
          <h2 className="market-section-title">{title}</h2>
          <div className="market-list-grid">
            {filteredPlayers.map((player) => {
              const isOwnerOrAdmin = user && (user.role === 'Admin' || player.user?._id === user._id);
              return (
                <div key={player._id} className="market-card-simplified">
                  <div className="market-profile-photo">
                    <img
                      src={
                        player.profilePhoto ||
                        (player.photos?.length > 0 ? player.photos[0] : '/default-profile.jpg')
                      }
                      alt={`Foto de ${player.name}`}
                      className="player-profile-img"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/default-profile.jpg';
                      }}
                    />
                  </div>

                  <h2 className="player-name">{player.name}</h2>
                  <div className="player-position">Posição: {player.position}</div>
                  <div className="player-age">Idade: {player.age}</div>

                  <div className="market-card-actions">
                    <button
                      onClick={() => handleViewDetails(player._id)}
                      className="market-details-button"
                    >
                      Ver Detalhes
                    </button>
                    {isOwnerOrAdmin && (
                      <button
                        onClick={() => handleEditPlayer(player._id)}
                        className="market-edit-button"
                      >
                        Editar
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );

  if (loading) return <div className="market-loading">Carregando jogadores...</div>;
  if (error) return <div className="market-error">{error}</div>;

  const jogadores = players.filter(p => !['Árbitro', 'Narrador'].includes(p.position));
  const arbitros = players.filter(p => p.position === 'Árbitro');
  const narradores = players.filter(p => p.position === 'Narrador');

  return (
    <div className="market-list-container">
      {renderSection('👟 Jogadores de Linha', jogadores)}
      {renderSection('⚖️ Árbitros', arbitros)}
      {renderSection('🎙️ Narradores', narradores)}
      {jogadores.length + arbitros.length + narradores.length === 0 && (
        <div className="market-empty">Nenhum participante disponível no mercado</div>
      )}
    </div>
  );
};

export default MarketList;
